var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadiconDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 23.666V31.2216C35 32.2235 34.602 33.1844 33.8935 33.8929C33.185 34.6013 32.2242 34.9993 31.2222 34.9993H4.77778C3.77585 34.9993 2.81496 34.6013 2.10649 33.8929C1.39801 33.1844 1 32.2235 1 31.2216V23.666",
    stroke: "#EAC7B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55566 14.2227L18.0001 23.6671L27.4446 14.2227",
    stroke: "#EAC7B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 23.6667V1",
    stroke: "#EAC7B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadiconDoc);
export default __webpack_public_path__ + "static/media/downloadicon-doc.266bcb9f17bbc660370c65b80d222ba9.svg";
export { ForwardRef as ReactComponent };